@if (icon || (highlight && !disabled)) {
    <i class="{{highlight ? 'fa fa-exclamation-circle' : icon}} item-icon"></i>
}

<ng-content></ng-content>
